import { render, staticRenderFns } from "./DepositOverview.vue?vue&type=template&id=26532ca0&scoped=true&"
import script from "./DepositOverview.vue?vue&type=script&lang=js&"
export * from "./DepositOverview.vue?vue&type=script&lang=js&"
import style0 from "./DepositOverview.vue?vue&type=style&index=0&id=26532ca0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26532ca0",
  null
  
)

export default component.exports